<template>
  <div class="main">

    <!-- <Tab class="tab" ref="Tab" :tabIdx="tabIdx" :data="tabData" @onToggleTab="onToggleTab" /> -->

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="add" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">

      <template slot="detail" slot-scope="scope">
        <div class="detail" @click="goDetail(scope.params.id)">
          点此维护
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState, mapMutations } from "vuex";

export default {
  mixins: [tableMixin],
  data() {
    return {
      tabIdx: 0,
      tabData: [
        {
          name: "在用",
        },
        {
          name: "停用",
        },
      ],
      baseUrl: 'custom',
      formInline: {
        is_status: '在用',
      },
      baseParams: ['is_status'],
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
          className: "carcap",
        },
        {
          label: "公司名称",
          keyName: "pname",
          placeholder: "请填写公司名称",
          type: "text",
        },
        {
          label: "联系人",
          keyName: "member",
          placeholder: "请填写联系人",
          type: "text",
        },
      ],
      cols: [
        { keyName: "name", label: "公司名称", minwidth: 150 },
        { keyName: "member", label: "联系人", minwidth: 120 },
        { keyName: "phone", label: "联系电话", minwidth: 120 },
        { keyName: "address", label: "公司地址", minwidth: 120 },
        { keyName: "industry", label: "所属行业", minwidth: 120 },
        { keyName: "product", label: "主营业务", minwidth: 120 },
        { keyName: "fleetname", label: "所属车队长", minwidth: 120 },
        { keyName: "addname", label: "添加人", minwidth: 120 },
        { keyName: "detail", label: "维护记录", slot: 'detail', minwidth: 120 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/customer/detail?id=${id}&mode=edit`
            );
          },
        },
        {
          class: 'kaibtn',
          title: '开票信息',
          img: require('@/assets/img/kai.png'),
          unimg: require('@/assets/img/kai1.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/customer/kai?id=${id}&mode=kai`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },

      ],
      // baseParams: ['fleet'],
      team: [],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      console.log(this.$route.params)
      // const { idx } = this.$route.params
      // this.formInline.iswork = iswork || 1
      // this.page = 1
      this.getParams()
      // console.log(iswork)
    },
  },
  methods: {
    ...mapMutations([
      'setState'
    ]),
    getParams() {
      const { idx } = this.$route.params

      this.formInline.is_status = idx == 1 ? '在用' : '停用'

      this.getList()
    },
    goDetail(id) {
      this.$router.push(
        `/customer/view?id=${id}`
      );
    },
    add() {
      this.$router.push(
        `/customer/detail?mode=add`
      );
    },
    onToggleTab({ index }) {
      // this.tabIdx = index;
      console.log(index)
      if (index == 1) {
        this.$set(this.formInline, 'is_status', '停用')
      } else {
        this.$set(this.formInline, 'is_status', '在用')
      }
      this.getList()
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(0, 1)
      this.baseParams.push('fleet')
    }
  },
  mounted() {
    this.getFleet(true);
    // const { user_group_id } = this.user
    // if (user_group_id == 5) {
    //   // 由于本身没有baseParams，有了baseParams手动触发首次请求
    //   this.getList();
    // }
    this.getParams();
  },
};
</script>

<style lang="less" scoped>
/deep/.detail {
  font-size: 14px;
  font-weight: 400;
  color: #2691FF;
  cursor: pointer;
}

.main .tab {
  /deep/ .el-tabs__header {
    padding: 0;

    .el-tabs__nav {
      .el-tabs__active-bar {
        height: 0;
      }

      .el-tabs__item {
        width: auto;
        height: 40px;
        line-height: 40px;
        margin: 0 10px;
        padding: 0 20px;
        transition: border-color .3s, background-color .3s, color .3s;

        &.is-active {
          border-bottom: 3px solid #2691FF;
          box-sizing: border-box;
          transition: border-color .3s, background-color .3s, color .3s;
        }
      }
    }
  }
}
</style>